<!-- Outermost Main Container -->
<div class="overflow-y-auto w-full h-full pb-20 bg-slate-50/60 min-h-screen text-slate-800 custom-scrollbar">

  <!-- Header Banner with Gradient -->
  <div class="relative pt-4 pb-8 px-4 rounded-b-[2rem] shadow-md text-white bg-(--background-color)">
    <!-- Top Bar: Back Button & Page Title -->
    <div class="flex items-center justify-between">
      <button (click)="goback()" type="button"
        class="w-10 h-10 bg-white/20 hover:bg-white/30 backdrop-blur-md rounded-full flex items-center justify-center transition-all active:scale-95 shadow-sm text-white border border-white/20"
        aria-label="Go Back">
        <i class="fa-solid fa-arrow-left text-base"></i>
      </button>

      <!-- <h1 class="text-base text-(--main-color) font-bold tracking-wide drop-shadow-sm text-center flex-1 pr-10">
        {{ currentLang === 'TH' ? 'ศูนย์แจ้งปัญหา & ช่วยเหลือ' : 'Help & Support Center' }}
      </h1> -->
    </div>

    <!-- Banner Welcome Text -->
    <div class="mb-4 text-center px-2">
      <h2 class="text-lg text-amber-500 font-bold mb-1">
        {{ currentLang === 'TH' ? 'พบปัญหาในการใช้งานหรือไม่?' : 'Encountering any issues?' }}
      </h2>
      <p class="text-xs text-white/90 font-light">
        {{ currentLang === 'TH' ? 'เลือกหมวดหมู่เพื่อโทรติดต่อเจ้าหน้าที่สายด่วน ดำเนินการเปิดเคสช่วยเหลือทันที' :
        'Select a category to call our support line. Our staff will open a ticket for you.' }}
      </p>
    </div>

    <!-- Quick Search Input -->
    <div class="relative max-w-md mx-auto">
      <div
        class="relative flex items-center bg-white/95 backdrop-blur-md rounded-2xl shadow-lg border border-white/40 overflow-hidden text-slate-700">
        <span class="pl-3 text-[14px] text-slate-400 flex items-center">
          <i class="fa-solid fa-magnifying-glass"></i>
        </span>
        <input type="text" [(ngModel)]="searchText"
          [placeholder]="currentLang === 'TH' ? 'ค้นหาประเภทปัญหา เช่น ชำระเงิน, EV, ส่วนลด...' : 'Search issues e.g. Payment, EV, Discount...'"
          class="w-full py-2.5 px-2 text-sm bg-transparent outline-none text-slate-800 placeholder-slate-400" />
        <button *ngIf="searchText" (click)="searchText = ''" type="button"
          class="pr-3 text-slate-400 hover:text-slate-600 transition-colors flex items-center">
          <i class="fa-solid fa-circle-xmark text-sm"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Content Container -->
  <div class="px-4 mt-5 space-y-6 max-w-md mx-auto">

    <!-- Categories Section Header -->
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-2">
        <div class="w-2 h-5 bg-amber-400 rounded-full"></div>
        <h2 class="text-sm font-bold text-slate-800">
          {{ currentLang === 'TH' ? 'เลือกหัวข้อเพื่อแจ้งปัญหา' : 'Select Issue to Report' }}
        </h2>
      </div>
      <span class="text-xs text-slate-400">
        {{ filteredCategories.length }} {{ currentLang === 'TH' ? 'หมวดหมู่' : 'items' }}
      </span>
    </div>

    <!-- No Results Found State -->
    <div *ngIf="filteredCategories.length === 0"
      class="bg-white rounded-2xl p-6 text-center border border-slate-100 shadow-sm">
      <div class="w-12 h-12 bg-amber-50 text-amber-500 rounded-full flex items-center justify-center mx-auto mb-3">
        <i class="fa-solid fa-circle-exclamation text-xl"></i>
      </div>
      <p class="text-sm font-semibold text-slate-700">
        {{ currentLang === 'TH' ? 'ไม่พบหมวดหมู่ปัญหาที่ค้นหา' : 'No matching categories found' }}
      </p>
      <p class="text-xs text-slate-400 mt-1">
        {{ currentLang === 'TH' ? 'กรุณาโทรติดต่อสายด่วน เพื่อแจ้งปัญหาแก่เจ้าหน้าที่โดยตรง' : 'Please call our hotline
        to report your issue directly.' }}
      </p>
      <button (click)="callSupport()" type="button"
        class="mt-4 px-4 py-2 text-slate-900 text-xs font-bold rounded-xl shadow-sm hover:opacity-90 transition-opacity"
        style="background: linear-gradient(to right, var(--main-color, #ffc527), var(--soft-color, #ffd95d));">
        {{ currentLang === 'TH' ? 'โทรออกสายด่วน' : 'Call Support Hotline' }}
      </button>
    </div>

    <!-- Categories Cards Grid -->
    <div class="grid grid-cols-1 gap-3">
      <div *ngFor="let cat of filteredCategories" (click)="onCategoryClick(cat)"
        class="group relative bg-white/95 backdrop-blur-sm border border-slate-100 rounded-2xl p-4 shadow-sm hover:shadow-md active:scale-[0.99] transition-all duration-200 cursor-pointer overflow-hidden flex items-start space-x-3.5">

        <!-- Category Icon Box -->
        <div
          [class]="'w-12 h-12 rounded-2xl flex items-center justify-center shrink-0 border shadow-sm transition-transform group-hover:scale-105 ' + cat.colorBg">
          <i [class]="cat.icon + ' text-xl ' + cat.iconColor"></i>
        </div>

        <!-- Category Text & Details -->
        <div class="flex-1 min-w-0 pr-10">
          <div class="flex items-center space-x-2 mb-1">
            <h3 class="text-sm font-bold text-slate-800 group-hover:text-amber-600 transition-colors truncate">
              {{ currentLang === 'TH' ? cat.titleTH : cat.titleEN }}
            </h3>
            <span *ngIf="cat.badgeTH"
              class="px-2 py-0.5 text-[10px] font-medium rounded-full bg-amber-100 text-amber-800 border border-amber-200 shrink-0">
              {{ currentLang === 'TH' ? cat.badgeTH : cat.badgeEN }}
            </span>
          </div>
          <p class="text-xs text-slate-500 line-clamp-2 leading-relaxed font-light">
            {{ currentLang === 'TH' ? cat.descTH : cat.descEN }}
          </p>
        </div>

        <!-- Arrow Action Icon -->
        <div
          class="absolute right-4 top-1/2 -translate-y-1/2 w-7 h-7 rounded-full bg-slate-50 group-hover:bg-amber-400 group-hover:text-white text-slate-400 flex items-center justify-center transition-all shadow-sm">
          <i class="fa-solid fa-chevron-right text-xs"></i>
        </div>
      </div>
    </div>

    <!-- Hotline / Call Center Contact Card -->
    <div
      class="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 rounded-2xl p-4 shadow-md text-white relative overflow-hidden">
      <!-- Decorative Background Circles -->
      <div class="absolute -right-6 -bottom-6 w-24 h-24 bg-amber-400/10 rounded-full blur-xl pointer-events-none"></div>

      <div class="flex items-center justify-between relative z-10">
        <div class="flex items-center space-x-3">
          <div
            class="w-11 h-11 bg-amber-400/20 text-amber-400 border border-amber-400/30 rounded-2xl flex items-center justify-center shrink-0">
            <i class="fa-solid fa-headset text-xl"></i>
          </div>
          <div>
            <div class="flex items-center space-x-2">
              <h3 class="text-sm font-bold text-white">
                {{ currentLang === 'TH' ? 'ช่องทางติดต่อสายด่วน' : 'Hotline Call Center' }}
              </h3>
            </div>
            <p class="text-xs text-slate-300 mt-0.5">
              {{ phone }}
            </p>
          </div>
        </div>

        <button (click)="callSupport()" type="button"
          class="px-3.5 py-2 bg-gradient-to-r from-amber-400 to-amber-500 text-slate-950 font-bold text-xs rounded-xl shadow-md hover:brightness-105 active:scale-95 transition-all flex items-center space-x-1.5 shrink-0">
          <i class="fa-solid fa-phone text-xs"></i>
          <span>{{ currentLang === 'TH' ? 'โทรออก' : 'Call' }}</span>
        </button>
      </div>
    </div>

    <!-- Info Banner for Call Center Process -->
    <div class="bg-blue-50/80 border border-blue-100 rounded-2xl p-3.5 flex items-start space-x-3 text-blue-900">
      <i class="fa-solid fa-circle-info text-base text-blue-600 shrink-0 mt-0.5"></i>
      <div class="text-xs leading-relaxed font-light">
        <strong class="font-semibold block mb-0.5">{{ currentLang === 'TH' ? 'ข้อมูลกระบวนการแจ้งปัญหา' : 'Support
          Ticket Notice' }}</strong>
        {{ currentLang === 'TH'
        ? 'ผู้ใช้งานจะไม่ต้องบันทึกรายละเอียดตั๋วปัญหาด้วยตนเอง เพื่อความสะดวกรวดเร็ว เจ้าหน้าที่ฝ่ายบริการลูกค้า (Call
        Center) จะเป็นผู้จัดประเภทและเปิดเคสช่วยเหลือในระบบให้ท่านเองทันที'
        : 'Users do not need to fill out forms. Our customer support staff will verify details, classify issue types,
        and open tickets directly in the system for you.' }}
      </div>
    </div>

    <!-- FAQ Section -->
    <div class="pt-2 space-y-3">
      <div class="flex items-center space-x-2">
        <div class="w-2 h-5 bg-amber-400 rounded-full"></div>
        <h2 class="text-sm font-bold text-slate-800">
          {{ currentLang === 'TH' ? 'คำถามที่พบบ่อย (FAQ)' : 'Frequently Asked Questions' }}
        </h2>
      </div>

      <div class="space-y-2">
        <div *ngFor="let faq of faqs; let i = index"
          class="bg-white/95 backdrop-blur-sm border border-slate-100 rounded-2xl overflow-hidden shadow-sm transition-all">
          <button (click)="toggleFaq(i)" type="button"
            class="w-full p-3.5 text-left flex items-center justify-between space-x-2 hover:bg-slate-50/50 transition-colors">
            <span class="text-xs font-semibold text-slate-700 leading-snug">
              {{ currentLang === 'TH' ? faq.questionTH : faq.questionEN }}
            </span>
            <i class="fa-solid fa-chevron-down text-slate-400 text-xs transition-transform duration-200 shrink-0"
              [ngClass]="{ 'rotate-180 text-amber-500': faq.isOpen }"></i>
          </button>

          <div *ngIf="faq.isOpen"
            class="px-3.5 pb-3.5 pt-1 text-xs text-slate-500 border-t border-slate-50 bg-slate-50/30 leading-relaxed">
            {{ currentLang === 'TH' ? faq.answerTH : faq.answerEN }}
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Back Navigation Link -->
    <div class="text-center pt-2 pb-4">
      <button (click)="goback()" type="button"
        class="inline-flex items-center space-x-1.5 text-xs font-medium text-slate-400 hover:text-amber-500 transition-colors">
        <i class="fa-solid fa-arrow-left text-xs"></i>
        <span>{{ currentLang === 'TH' ? 'ย้อนกลับไปยังหน้าหลัก' : 'Back to Home' }}</span>
      </button>
    </div>

  </div>
</div>

<!-- Custom Glassmorphic Call Confirmation Modal Overlay -->
<div *ngIf="showCallModal"
  class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs anim-fade-in">
  <div
    class="bg-white/95 backdrop-blur-md border border-slate-100 rounded-[2rem] p-6 w-full max-w-sm shadow-2xl relative anim-fade-in-up text-center">

    <!-- Modal Icon -->
    <div
      class="w-14 h-14 bg-amber-50 border border-amber-100 text-amber-500 rounded-2xl flex items-center justify-center mx-auto mb-4 shadow-sm">
      <i class="fa-solid fa-phone-volume text-2xl"></i>
    </div>

    <!-- Modal Title -->
    <h3 class="text-sm font-bold text-slate-800 mb-1">
      {{ currentLang === 'TH' ? 'ยืนยันติดต่อสายด่วน Call Center' : 'Confirm Support Call' }}
    </h3>

    <!-- Selected Category -->
    <div class="my-3">
      <span
        class="text-xs text-amber-700 font-semibold bg-amber-100/50 rounded-full py-1 px-3 inline-block border border-amber-200/50">
        {{ currentLang === 'TH' ? selectedCategoryForCall?.titleTH : selectedCategoryForCall?.titleEN }}
      </span>
    </div>

    <!-- Description -->
    <p class="text-xs text-slate-500 leading-relaxed mb-6 px-2 font-light">
      {{ currentLang === 'TH'
      ? 'เพื่อความสะดวกรวดเร็วในการตรวจสอบข้อมูลและการเปิดตั๋วแจ้งปัญหา
      เจ้าหน้าที่จะเป็นผู้รับเรื่องและเปิดเคสให้ท่านทันทีผ่านทางสายโทรศัพท์'
      : 'To ensure fast service, our hotline support staff will verify details, classify issues, and open tickets
      directly in the system for you.' }}
    </p>

    <!-- Action Buttons -->
    <div class="grid grid-cols-2 gap-3">
      <button (click)="closeCallModal()" type="button"
        class="w-full py-2.5 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold text-xs rounded-xl active:scale-95 transition-all">
        {{ currentLang === 'TH' ? 'ยกเลิก' : 'Cancel' }}
      </button>
      <button (click)="confirmCall()" type="button"
        class="w-full py-2.5 text-slate-900 font-bold text-xs rounded-xl active:scale-95 transition-all shadow-md flex items-center justify-center space-x-1.5"
        style="background: linear-gradient(to right, var(--main-color, #ffc527), var(--soft-color, #ffd95d));">
        <i class="fa-solid fa-phone text-xs"></i>
        <span>{{ currentLang === 'TH' ? 'โทรออกสายด่วน' : 'Call Hotline' }}</span>
      </button>
    </div>

  </div>
</div>